import {  
    Box, 
    List, 
    MenuItem, 
} from '@mui/material';

import { Trans } from 'react-i18next';

import { Route, Routes, useNavigate } from 'react-router-dom';
import EditLocationPage from './EditLocationPage';
import EditHolidayPage from './EditHolidayPage';
import EditFlexTimeAccountPage from './EditFlexTimeAccountPage';
import EditAccountCreditPage from './EditAccountCreditPage';

function InstituteConfigurationPage() {
    const navigate = useNavigate();

    return (
        <Box sx={{ display: 'flex' }}>
            <List>
                <MenuItem onClick={()=>{navigate('/institute-configuration/')}}><Trans i18nKey="standorte" ns="instituteConfigurationPage">Standorte</Trans></MenuItem>
                <MenuItem onClick={()=>{navigate('/institute-configuration/holidays')}}><Trans i18nKey="feiertage" ns="instituteConfigurationPage">Feiertage</Trans></MenuItem>
                <MenuItem onClick={()=>{navigate('/institute-configuration/account-credit')}}><Trans i18nKey="zeitguthaben" ns="instituteConfigurationPage">Max. Zeitguthaben</Trans></MenuItem>
                <MenuItem onClick={()=>{navigate('/institute-configuration/flex-time-account')}}><Trans i18nKey="arbeitszeitkonto" ns="instituteConfigurationPage">Arbeitszeitkonto</Trans></MenuItem>
            </List>
            <Routes>
                <Route exact path='/' element={<EditLocationPage />}></Route>
                <Route exact path='/holidays' element={<EditHolidayPage />}> </Route>
                <Route exact path='/account-credit' element={<EditAccountCreditPage />}> </Route>
                <Route exact path='/flex-time-account' element={<EditFlexTimeAccountPage />}> </Route>
            </Routes>
        </Box >
    );
};

export default InstituteConfigurationPage 
